export default "__VITE_ASSET__C58tW8gm__"